package com.narbase.letsgo.web.views.voiceassistant

import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantConnectionHealthDto
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantPromptsDto
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantSettingsDto
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantTurnLogDto
import com.narbase.letsgo.dto.dto
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantEngine
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantField
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantEngineDecisionConfidence
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantMediumConfidenceAction
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantSpeechDetector
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantModelRole
import com.narbase.letsgo.web.network.basicNetworkCall
import com.narbase.letsgo.web.network.remoteProcess
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.CheckVoiceAssistantMcpHealthEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.CheckVoiceAssistantModelsHealthEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.GetVoiceAssistantSettingsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.ListVoiceAssistantProviderModelsEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.TestVoiceAssistantEngineEndpoint
import com.narbase.letsgo.web.routing.domain.admin.voiceassistant.UpsertVoiceAssistantSettingsEndpoint
import com.narbase.letsgo.web.utils.BasicUiState

class VoiceAssistantManagementViewModel {

    val settingsUiState = Observable<BasicUiState>()
    val upsertUiState = Observable<BasicUiState>()
    val modelsHealthUiState = Observable<BasicUiState>()
    val mcpHealthUiState = Observable<BasicUiState>()
    val engineTestUiState = Observable<BasicUiState>()

    var settings: VoiceAssistantSettingsDto? = null
        private set

    var defaultPrompts: VoiceAssistantPromptsDto? = null
        private set

    var modelsHealth: CheckVoiceAssistantModelsHealthEndpoint.Response? = null
        private set

    var mcpHealth: VoiceAssistantConnectionHealthDto? = null
        private set

    var engineTestTurn: VoiceAssistantTurnLogDto? = null
        private set

    fun getSettings() {
        basicNetworkCall(settingsUiState) {
            val response = GetVoiceAssistantSettingsEndpoint.remoteProcess(GetVoiceAssistantSettingsEndpoint.Request()).data
            settings = response.settings
            defaultPrompts = response.defaultPrompts
        }
    }

    fun saveSettings(edited: VoiceAssistantSettingsDto) {
        basicNetworkCall(upsertUiState) {
            settings = UpsertVoiceAssistantSettingsEndpoint
                .remoteProcess(UpsertVoiceAssistantSettingsEndpoint.Request(edited)).data.settings
        }
    }

    fun checkModelsHealth(edited: VoiceAssistantSettingsDto) {
        basicNetworkCall(modelsHealthUiState) {
            modelsHealth = CheckVoiceAssistantModelsHealthEndpoint
                .remoteProcess(CheckVoiceAssistantModelsHealthEndpoint.Request(edited)).data
        }
    }

    fun checkMcpHealth(edited: VoiceAssistantSettingsDto) {
        basicNetworkCall(mcpHealthUiState) {
            mcpHealth = CheckVoiceAssistantMcpHealthEndpoint
                .remoteProcess(CheckVoiceAssistantMcpHealthEndpoint.Request(edited)).data.elasticsearchMcp
        }
    }

    fun testEngine(
        edited: VoiceAssistantSettingsDto,
        field: VoiceAssistantField,
        typedTranscript: String?,
        recording: EngineTestRecording?,
    ) {
        basicNetworkCall(engineTestUiState) {
            engineTestTurn = TestVoiceAssistantEngineEndpoint.remoteProcess(
                TestVoiceAssistantEngineEndpoint.Request(
                    settings = edited,
                    field = field.dto(),
                    typedTranscript = typedTranscript,
                    audioBase64 = recording?.base64,
                    audioMimeType = recording?.mimeType,
                )
            ).data.turn
        }
    }

    fun listProviderModels(
        role: VoiceAssistantModelRole,
        edited: VoiceAssistantSettingsDto,
        transcriptionFallbackIndex: Int?,
        uiState: Observable<BasicUiState>,
        onListed: (ListVoiceAssistantProviderModelsEndpoint.Response) -> Unit,
    ) {
        basicNetworkCall(uiState) {
            onListed(
                ListVoiceAssistantProviderModelsEndpoint
                    .remoteProcess(ListVoiceAssistantProviderModelsEndpoint.Request(edited, role.dto(), transcriptionFallbackIndex)).data
            )
        }
    }

    fun engineOptions() = VoiceAssistantEngine.values()

    fun speechDetectorOptions() = VoiceAssistantSpeechDetector.values()

    fun mediumConfidenceActionOptions() = VoiceAssistantMediumConfidenceAction.values()

    fun engineDecisionConfidenceOptions() = VoiceAssistantEngineDecisionConfidence.values()

    fun fieldOptions() = VoiceAssistantField.values()

    class EngineTestRecording(val fileName: String, val base64: String, val mimeType: String?)
}
